// components/MyPage/ProfileCustomizer.jsx
import { Tabs, Tab, Box, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useState } from 'react';
import TitleSettings from './TitleSettings';
import MyEmoticons from './MyEmoticons';

export default function ProfileCustomizer() {
    const [tab, setTab] = useState(0);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    return (
        <Box>
            <Tabs
                value={tab}
                onChange={(_, v) => setTab(v)}
                centered={!isMobile}
                variant={isMobile ? 'fullWidth' : 'standard'}
                sx={{ mb: 2 }}
            >
                <Tab label="칭호" />
                <Tab label="이모티콘" />
            </Tabs>

            {tab === 0 && <TitleSettings />}
            {tab === 1 && <MyEmoticons />}
        </Box>
    );
}
